import { useEffect } from 'react'

import { useBoolean } from 'ahooks'
import { Popover, PopoverProps } from 'antd'
import { isNull } from 'lodash'

export const FeedbackPopover = (props: PopoverProps) => {
  const [open, openAction] = useBoolean(false)
  const shouldShow = !isNull(props.content)

  useEffect(() => {
    if (!shouldShow) {
      return
    }

    openAction.setTrue()

    const timer = setTimeout(() => {
      openAction.setFalse()
    }, 1500)

    return () => {
      clearTimeout(timer)
    }
  }, [shouldShow])

  return (
    <Popover
      open={shouldShow && open}
      placement='top'
      trigger='hover'
      onOpenChange={openAction.set}
      {...props}
    />
  )
}
